import React, { useState } from 'react'
import { Box, Button, ListSubheader, Menu, MenuItem, Typography } from '@mui/material'

import { secondaryButtonSx } from '@components'
import { dsColorNew } from '@palette'
import { TOOL_HEIGHT } from '../../../@components/MarketBar'


const GROUP = [['country', 'Country'], ['type', 'Office type'], ['none', 'No grouping']]

/** "Rows" (D3): group by and sort in one control, one toolbar row */
export default function RowsMenu({ grp, sort, columns, onGroup, onSort }) {
	const [anchor, setAnchor] = useState(null)
	const col = sort.key.startsWith('col:') ? columns[+sort.key.split(':')[1]] : sort.key.startsWith('change:') ? columns[+sort.key.split(':')[1]] : null
	const sortText = sort.key === 'name' ? 'A–Z' : sort.key.startsWith('change') ? `change in ${col?.label}` : `${sort.dir === 'desc' ? 'most above' : 'most below'} in ${col?.label}`
	const j = col ? columns.indexOf(col) : 0
	const label = columns[j]?.label || ''
	const pick = (key, dir) => { onSort({ key, dir }); setAnchor(null) }
	return <>
		<Button variant="outlined" onClick={e => setAnchor(e.currentTarget)} aria-haspopup="menu"
			sx={{ ...secondaryButtonSx, height: TOOL_HEIGHT, borderRadius: '10px', fontSize: 13, backgroundColor: dsColorNew.filterInputBg, whiteSpace: 'nowrap', flexShrink: 0 }}>
			<Box component="span" sx={{ color: dsColorNew.textMuted, mr: 0.5 }}>Rows</Box>{GROUP.find(g => g[0] === grp)?.[1].toLowerCase()} · {sortText} ▾
		</Button>
		<Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
			<ListSubheader>Group by</ListSubheader>
			{GROUP.map(([v, l]) => <MenuItem key={v} selected={v === grp} onClick={() => { onGroup(v); setAnchor(null) }}>{l}</MenuItem>)}
			<ListSubheader>Sort offices</ListSubheader>
			<MenuItem selected={sort.key === 'name'} onClick={() => pick('name', 'asc')}>Name, A–Z</MenuItem>
			{!!columns.length && <MenuItem selected={sort.key === `col:${j}` && sort.dir === 'desc'} onClick={() => pick(`col:${j}`, 'desc')}>Most above the market in {label}</MenuItem>}
			{!!columns.length && <MenuItem selected={sort.key === `col:${j}` && sort.dir === 'asc'} onClick={() => pick(`col:${j}`, 'asc')}>Most below the market in {label}</MenuItem>}
			{!!columns.length && <MenuItem selected={sort.key === `change:${j}`} onClick={() => pick(`change:${j}`, 'desc')}>Biggest change in {label}</MenuItem>}
			<Typography sx={{ px: 2, py: 1, fontSize: 12, color: dsColorNew.textMuted, maxWidth: 300 }}>Or click a column header to sort by it. Groups keep their order; offices are sorted inside each group.</Typography>
		</Menu>
	</>
}
